import _ from 'lodash'
import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/bi-messages'
import VALUES from 'core/data-model/constants/values'

export const getThaiBasicPlanDetailsLabelFn = () => (displayProduct) =>
  Mustache.render(MESSAGES.BASIC_PLAN_DETAILS, {
    name: displayProduct.nameThai,
    code: VALUES.CODE_12PL_SIO || VALUES.CODE_12PL_GIO ? displayProduct.basicPlanCode : displayProduct.code,
  })

export const getThaiBasicPlanDetailsLabelFnWithOutCode = (displayProduct) =>
  Mustache.render(MESSAGES.BASIC_PLAN_DETAILS_WITHOUT_CODE, {
    name: displayProduct.basicPlanName,
  })

export const getPLBBasicPlanLabel = () => (displayProduct) => _.get(displayProduct, 'name').replace(/ \(PLB.*/, '')

export const getS7BasicPlanLabel = () => (displayProduct) => MESSAGES.CONTRACTS + _.get(displayProduct, 'nameThai')

export const getThaiBasicPlanLabel = () => (displayProduct) => displayProduct.nameThai

export const getBasicPlanNameLabel = () => (displayProduct) => displayProduct.basicPlanName

export const getBasicPlanDetailsLabelFnLifeReady = (displayProduct) =>
  Mustache.render(MESSAGES.BASIC_PLAN_DETAILS, {
    name:
      VALUES.LIFEREADY_CAMPAIGN_CODE.includes(displayProduct.code) ||
      VALUES.CANCERX5_CAMPAIGN_CODE.includes(displayProduct.code)
        ? MESSAGES.LIFE_READY_PACKAGE_NAME_THAI
        : VALUES.LIFETREASURE_GROUP_CODE.includes(displayProduct.code)
        ? MESSAGES.LIFE_TREASURE_NAME_THAI
        : displayProduct.basicPlanName,
    code: displayProduct.basicPlanCode,
  })

export const getBasicPlanDetailsLabelFn = () => (displayProduct) =>
  Mustache.render(MESSAGES.BASIC_PLAN_DETAILS, {
    name: MESSAGES.LIFE_PROTECT_18_NAMETHAI,
    code: displayProduct.basicPlanCode,
  })
